module.exports = __webpack_public_path__ + "img/awesome-meme.f97890b6.jpg";